<template>
  <PopDialog2
    title="방 정보 수정"
    :visible="props.visible"
    :okCallback="onOkClick"
    :cancelCallback="onCancelClick"
  >
    <div class="md-layout">
      <div class="md-layout-item md-size-50 mx-auto text-center mb-4">
        <!-- <h2 class="title mt-4">{{props.roomName}} 보일러</h2> -->
        <div class="modal-title-row mt-4">
          <h2 class="title mb-0">{{ isCoolingMode ? '에어컨' : '보일러' }}</h2>
          <button
            v-if="supportsCoolingToggle"
            type="button"
            :class="`btn btn-sm cooling-toggle ${isCoolingMode ? 'cooling-toggle-on' : 'cooling-toggle-off'}`"
            @click="onCoolingToggle"
          >
            냉방
          </button>
        </div>

        <div class="boiler-modal-body">
        <button
          type="button"
          class="boiler-power-btn mb-4"
          :class="isBoilerPowered ? 'boiler-power-btn--on' : 'boiler-power-btn--off'"
          :style="isBoilerPowered ? powerBtnOnStyle : undefined"
          @click="props.handlePowerClick"
        >
          <span class="boiler-power-btn__text">{{ powerCenterText }}</span>
        </button>

        <div class="boiler-modal-controls">
          <div class="boiler-modal-sliders px-2">
          <ListGroupItem class="boiler-modal-temp-row">
            <Slider
              name="희망온도"
              id="temperature"
              layout="stacked"
              thin
              filled-track
              :track-variant="isCoolingMode ? 'cooling' : 'boiler'"
              :default="targetTemp"
              :min="tempSliderMin"
              :max="tempSliderMax"
              :step="tempSliderStep"
              :isFloat="!isCoolingMode"
              value-suffix="°C"
              :disabled="deviceState(2) ? false : true"
              v-on:onSliderChanged="onTemperatureChanged"
            />
          </ListGroupItem>
          </div>
          <ListGroupItem class="boiler-modal-pattern-row px-2">
            <div class="container" style="padding-left: 0px; padding-right: 0px;">
              <div class="row">
                <div
                  :class="`col-3`"
                  :style="`margin-top: 8px`"
                >
                  <label :for="props.id" class="form-label w-normal">
                    패턴
                  </label>
                </div>
                <div class="col">
                  <div class="btn-group btn-group-toggle" data-toggle="buttons" style="width: 100%;">
                    <!-- <div class="form-check"> -->
                      <label :class="`btn ${currentPattern == 1 ? 'btn-primary' : 'btn-outline-primary'} ${currentPattern == 1 ? 'selected' : 'no-selected'}`" 
                        style="border-radius: 10px 0px 0px 10px;">
                        <input class="form-check-input" type="checkbox" id="p1" value="1" :checked="currentPattern == 1" @click="onSelectPatternClick" hidden>
                        <label class="form-check-label" for="p1">
                          P1
                        </label>
                      </label>

                      <label :class="`btn ${currentPattern == 2 ? 'btn-primary' : 'btn-outline-primary'} ${currentPattern == 2 ? 'selected' : 'no-selected'}`" 
                        style="border-radius: 0px 0px 0px 0px;">
                        <input class="form-check-input" type="checkbox" id="p2" value="2" :checked="currentPattern == 2" @click="onSelectPatternClick" hidden>
                        <label class="form-check-label" for="p2">
                          P2
                        </label>
                      </label>

                      <label :class="`btn ${currentPattern == 3 ? 'btn-primary' : 'btn-outline-primary'} ${currentPattern == 3 ? 'selected' : 'no-selected'}`" 
                        style="border-radius: 0px 0px 0px 0px;">
                        <input class="form-check-input" type="checkbox" id="p3" value="3" :checked="currentPattern == 3" @click="onSelectPatternClick" hidden>
                        <label class="form-check-label" for="p3">
                          P3
                        </label>
                      </label>

                      <label :class="`btn ${currentPattern == 4 ? 'btn-primary' : 'btn-outline-primary'} ${currentPattern == 4 ? 'selected' : 'no-selected'}`" 
                        style="border-radius: 0px 0px 0px 0px;">
                        <input class="form-check-input" type="checkbox" id="p4" value="4" :checked="currentPattern == 4" @click="onSelectPatternClick" hidden>
                        <label class="form-check-label" for="p4">
                          P4
                        </label>
                      </label>

                      <label :class="`btn ${currentPattern == 5 ? 'btn-primary' : 'btn-outline-primary'} ${currentPattern == 5 ? 'selected' : 'no-selected'}`" 
                        style="border-radius: 0px 10px 10px 0px;">
                        <input class="form-check-input" type="checkbox" id="p5" value="5" :checked="currentPattern == 5" @click="onSelectPatternClick" hidden>
                        <label class="form-check-label" for="p5">
                          P5
                        </label>
                      </label>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem 
            v-if="isOwnerZone"
            style="padding-top: 0.3rem; padding-bottom: 0.3rem;"
          >
            <div class="container" style="padding-left: 0px; padding-right: 0px;">
              <div class="row mt-1">
                <div :class="`col-3`" :style="`margin-top: 8px`" />
                <div class="col">
                  <div class="flex-fill">
                    <div
                      class="fw-400 text-muted text-end me-1"
                      style="font-size: 0.8rem"
                      @click="onSettingTempPatternsClick"
                    >
                      패턴 정보&설정&nbsp;<i class="fa fa-chevron-right"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div :class="`col-3`" :style="`margin-top: 8px`" />
                <div class="col">
                  <div class="flex-fill">
                    <div
                      class="fw-400 text-muted text-end me-1"
                      style="font-size: 0.8rem"
                      @click="onSettingTempDeviceClick"
                    >
                      장치 설정&nbsp;<i class="fa fa-chevron-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ListGroupItem>
        </div>
        </div>
      </div>
    </div>
  </PopDialog2>
        
  <BoilerItemPatternModal
    v-if="boilerItemPatternModal.visible"
    :visible="boilerItemPatternModal.visible"
    :cancelCallback="boilerItemPatternModal.hide"
    :roomName="props.roomName"
    :roomId="props.roomId"
    :isCoolingMode="isCoolingMode"
  />
  
  <BoilerItemSettingModal
    v-if="boilerItemSettingModal.visible"
    :visible="boilerItemSettingModal.visible"
    :cancelCallback="boilerItemSettingModal.hide"
    :roomName="props.roomName"
    :roomId="props.roomId"
  />
</template>

<script setup>
import { ref, defineProps, computed, getCurrentInstance, reactive, watch } from 'vue';
import { useStore } from 'vuex';
import { DeviceType, PowerState, ButtonConfig, MQTTTempCommand, AIRCON_SUPPORTED_MODELS } from '@/common/constants';
import { resolveTempControllerModel } from '@/common/utils/tempControllerModel';
import useMqttControl from '@/common/hooks/useMqttControl';
import useModal from '@/common/hooks/useModal';
import PopDialog2 from '@/common/components/popup/PopDialog2.vue';
import Slider from '@/common/components/widgets/Slider.vue';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import BoilerItemPatternModal from './BoilerItemPatternModal.vue';
import BoilerItemSettingModal from './BoilerItemSettingModal.vue';

const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const boilerItemPatternModal = reactive(useModal());
const boilerItemSettingModal = reactive(useModal());
const store = useStore();
const props = defineProps([
  'visible',
  'okCallback',
  'cancelCallback',
  'roomName',
  'roomId',
  'handlePowerClick'
]);

const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const isOwnerZone = computed(() => {
  return zone.value?.ownerId != undefined
    && store.getters['account']?._id != undefined
    && zone.value?.ownerId === store.getters['account']?._id;
});
const group = computed(() => {
  return zone.value.groups.find((g) => g._id === props.roomId);
});
const devices = computed(() => {
  return group.value ? group.value.devices : undefined;
});
const boilerDevices = computed(() => {
  return devices.value.filter(
    (d) => d.type === 2,
  );
});
const primaryBoilerDevice = computed(() => {
  if (!boilerDevices.value?.length) {
    return undefined;
  }
  return (
    boilerDevices.value.find((d) => !d.isVirtual) ||
    boilerDevices.value[0]
  );
});

const currentPattern = ref(primaryBoilerDevice.value?.item?.pattern ?? "0");

const currentTemp = computed(() => {
  if (boilerDevices.value.length === 0) {
    return 20;
  }

  let currentTemp = undefined;
  boilerDevices.value.forEach((device) => {
    if (currentTemp === undefined) {
      currentTemp = device.item?.currentTemp;
    }
  });
  return currentTemp;
});
const targetTemp = computed(() => {
  if (boilerDevices.value.length === 0) {
    return 18;
  }

  let targetTemp = 0;
  boilerDevices.value.forEach((device) => {
    if (device.item?.targetTemp > targetTemp) {
      targetTemp = device.item?.targetTemp;
    }
  });
  return targetTemp;
});
const deviceState = (type) => {
  return devices.value
    .filter((d) => d.type === type)
    .some((d) => d.item.onoff === PowerState.On);
};

const isCoolingMode = computed(() => {
  return primaryBoilerDevice.value?.item?.hcMode === 1;
});
/** 난방 9~35(0.5°C), 냉방 16~30(1°C) */
const tempSliderMin = computed(() => (isCoolingMode.value ? 16 : 9));
const tempSliderMax = computed(() => (isCoolingMode.value ? 30 : 35));
const tempSliderStep = computed(() => (isCoolingMode.value ? 1 : 0.5));

/** 냉방(에어컨) 전환은 T02 등 AIRCON_SUPPORTED_MODELS 만 지원 */
const supportsCoolingToggle = computed(() => {
  return boilerDevices.value.some((device) => {
    if (device?.isVirtual) {
      return false;
    }
    const model = resolveTempControllerModel(device, zone.value?.controllers);
    return AIRCON_SUPPORTED_MODELS.includes(model);
  });
});

const hexToRgb = (hex) => {
  const raw = String(hex || '').replace('#', '');
  const full = raw.length === 3 ? raw.split('').map((c) => c + c).join('') : raw;
  const n = parseInt(full, 16);
  if (Number.isNaN(n)) {
    return { r: 255, g: 224, b: 130 };
  }
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
};

const mixTowardWhite = (hex, amount) => {
  const { r, g, b } = hexToRgb(hex);
  const mix = (c) => Math.round(c + (255 - c) * amount);
  return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`;
};

const BOILER_TEMP_MIN = 9;
const BOILER_TEMP_MAX = 35;
const POWER_BORDER_PEAK_ALPHA = 0.52;

const boilerTempIntensity = (temp) => {
  const value = Number(temp);
  if (Number.isNaN(value)) {
    return 0.5;
  }
  return Math.max(0, Math.min(1, (value - BOILER_TEMP_MIN) / (BOILER_TEMP_MAX - BOILER_TEMP_MIN)));
};

const powerBorderOpacityForTemp = (temp, cooling = false) => {
  const ratio = boilerTempIntensity(temp);
  const factor = cooling ? ratio : 1 - ratio;
  return Math.max(0, POWER_BORDER_PEAK_ALPHA * factor);
};

/** 원형 버튼 색상·테두리는 희망온도(슬라이더) 기준 */
const powerBtnTargetTemp = ref(null);

watch(
  targetTemp,
  (value) => {
    const temp = Number(value);
    powerBtnTargetTemp.value = Number.isNaN(temp) ? 22 : temp;
  },
  { immediate: true },
);

const powerBtnColorTemp = computed(() => {
  const temp = Number(powerBtnTargetTemp.value);
  return Number.isNaN(temp) ? 22 : temp;
});

const isBoilerPowered = computed(() => deviceState(2));

/** 켜짐: 희망온도 기준 — 보일러 높을수록 진한 노랑, 에어컨 낮을수록 진한 파랑 */
const powerBtnOnStyle = computed(() => {
  const colorTemp = powerBtnColorTemp.value;
  const tempRatio = boilerTempIntensity(colorTemp);
  const cooling = isCoolingMode.value;
  const colorIntensity = cooling ? 1 - tempRatio : tempRatio;
  const paleBoost = cooling ? tempRatio : 1 - tempRatio;
  const base = cooling ? '#42a5f5' : '#ffb830';
  const { r, g, b } = hexToRgb(base);
  const centerMix = 0.55 + 0.43 * paleBoost;
  const midMix = 0.28 + 0.4 * paleBoost;
  const edgeMix = 0.14 + 0.62 * paleBoost;
  return {
    '--power-center': mixTowardWhite(base, centerMix),
    '--power-mid': mixTowardWhite(base, midMix),
    '--power-edge': mixTowardWhite(base, edgeMix),
    '--power-border': `rgba(168, 173, 180, ${powerBorderOpacityForTemp(colorTemp, cooling)})`,
    '--power-glow': `rgba(${r}, ${g}, ${b}, ${0.22 + 0.23 * colorIntensity})`,
    '--power-ring': `rgba(${r}, ${g}, ${b}, ${0.18 + 0.17 * colorIntensity})`,
    '--power-inset': `rgba(255, 255, 255, ${0.82 - 0.12 * colorIntensity})`,
  };
});

const powerCenterText = computed(() => {
  if (deviceState(2)) {
    return currentTemp.value;
  }
  return isCoolingMode.value ? '정지' : '외출중';
});

const onCoolingToggle = () => {
  if (!supportsCoolingToggle.value) {
    return;
  }
  const mode = isCoolingMode.value ? 0 : 1;
  emitter.emit('showLoading');
  try {
    boilerDevices.value.forEach((device) => {
      store.commit('home/setDeviceState', {
        deviceId: device._id,
        type: DeviceType.Boiler,
        state: { hcMode: mode },
      });
      mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.HcModeToggle, mode);
    });
    setTimeout(() => emitter.emit('hideLoading'), boilerDevices.value.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
  } catch (err) {
    emitter.emit('hideLoading');
  }
};

const onCancelClick = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
};

const onTemperatureChanged = (e) => {
  const nextTemp = Number(e);
  if (!Number.isNaN(nextTemp)) {
    powerBtnTargetTemp.value = nextTemp;
  }
  emitter.emit('showLoading');
  try {
    boilerDevices.value.forEach((device) => {
      if (device.item?.hcMode === 1) {
        const tempC = Math.round(parseFloat(e));
        mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.AirconTempTarget, tempC);
      } else {
        mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.TempTargetSet, e);
      }
    });
    setTimeout(() => emitter.emit('hideLoading'), boilerDevices.value.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
  } catch (err) {
    emitter.emit('hideLoading');
  }
};

const onSelectPatternClick = (e) => {
  if (e.target.value) {
    e.preventDefault();

    if (currentPattern.value == e.target.value) {
      currentPattern.value = '0';
    } else {
      currentPattern.value = e.target.value;
    }

    emitter.emit('showLoading');
    try {
      boilerDevices.value.forEach((device) => {
        mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.PatternModeSet, currentPattern.value);
      });
      setTimeout(() => emitter.emit('hideLoading'), boilerDevices.value.length > 1 ? ButtonConfig.delayBatch : ButtonConfig.delay);
    } catch (err) {
      emitter.emit('hideLoading');
    }
  }
}

const onSettingTempPatternsClick = () => {
  boilerItemPatternModal.show();
}

const onSettingTempDeviceClick = () => {
  boilerItemSettingModal.show();
}
</script>

<style scoped>
.modal-title-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  min-height: 2rem;
}

.modal-title-row .title {
  grid-column: 2;
  justify-self: center;
  text-align: center;
}

.modal-title-row .cooling-toggle {
  grid-column: 3;
  justify-self: end;
}

.cooling-toggle-off {
  color: #1f6bff;
  background-color: #ffffff;
  border: 1px solid #1f6bff;
}
.cooling-toggle-off:hover {
  color: #1f6bff;
  background-color: #eef4ff;
}
.cooling-toggle-on {
  color: #ffffff;
  background-color: #1f6bff;
  border: 1px solid #1f6bff;
}
.cooling-toggle-on:hover {
  color: #ffffff;
  background-color: #1a5ce0;
}
.selected:hover {
  color: #ffffff;
  background-color: #1f6bff;
}
.no-selected:hover {
  color: #1f6bff;
  background-color: #ffffff;
}

.boiler-modal-body {
  margin-top: 0.85rem;
}

.boiler-modal-controls {
  width: 100%;
  max-width: 100%;
}

.boiler-modal-sliders {
  width: 100%;
  max-width: 100%;
}

.boiler-modal-temp-row {
  padding-top: 0.15rem;
  padding-bottom: 0.55rem;
  border: none;
}

.boiler-modal-pattern-row {
  margin-top: 0.55rem;
  padding-top: 0.65rem;
  padding-bottom: 0.35rem;
}

.boiler-power-btn {
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  transition: background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease;
}

.boiler-power-btn__text {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1;
}

.boiler-power-btn--on {
  background: radial-gradient(
    circle at 50% 42%,
    var(--power-center) 0%,
    var(--power-mid) 48%,
    var(--power-edge) 100%
  );
  border: 2px solid var(--power-border, rgba(168, 173, 180, 0.52));
  box-shadow:
    0 0 0 1px var(--power-ring),
    0 6px 20px var(--power-glow),
    inset 0 2px 4px var(--power-inset, rgba(255, 255, 255, 0.75));
  color: #5c5348;
}

.boiler-power-btn--off {
  background: radial-gradient(circle at 50% 42%, #f8f9fa 0%, #eceff1 55%, #e2e6ea 100%);
  border: 2px solid #e5e7eb;
  box-shadow:
    inset 0 2px 5px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.04);
  color: #adb5bd;
}
</style>